
<div class="donnes-vibrations">
  <div class="info-box">

    <div class="control-points-box">
      <div class="btn-control-box">
        <div class="btn-control-box-content">
          @for (controlPoint of tabControlPointsForBtn(); track controlPoint; let i = $index) {
            <span class="">
              <a class="btn btn-primary c-item"
                (click)="changerTab(controlPoint.controlPointId, controlPoint.vibrationType, i)"
                [ngClass]="{'active':activeControlPointIndex() == i}">
                {{controlPoint.name}}
              </a>
            </span>
          }
        </div>
      </div>

      <div class="btn-box">
        <button title="Download" (click)="downloadFileVibration()"
          [disabled]="tabControlPointsForBtn().length < 1 || activeVibrationsNewModel() == undefined || activeVibrationsOldModel() != undefined"
          class="btn btn-primary btn-panel "><i class="fas fa-file-export"></i></button>
          <button title="Modify"
            [disabled]="tabControlPointsForBtn().length < 1 || (activeVibrationsNewModel() == undefined && activeVibrationsOldModel() == undefined)"
            class="btn btn-primary btn-panel" (click)="ouvrirModaleModif()"><i class="fas fa-edit"></i></button>
            <button title="Add" class="btn btn-primary btn-panel" (click)="ouvrirModaleAdd()"><i
            class="fas fa-plus"></i></button>
          </div>

        </div>

        @if (activeVibrationsNewModel() != undefined) {
          <div class="charts-info-box">
            <div class="charts-info-box-left">
              <!-- <div id="coteneur-table"> -->
              <table class="table-bordered">
                <tbody>
                  <tr class="no-border-right">
                    <td class="col-md-6 ">
                      <div class="td-align">
                        <b>
                          <span class="">{{'VIBRATION.SURPRESSION' | translate}}</span>
                        </b>
                      </div>
                    </td>
                    <td class="col-md-6 align-items-center">
                      <div class="td-align">
                        <span>{{ activeVibrationsNewModel().surpression }} </span>
                      </div>
                    </td>
                  </tr>
                  <tr class="no-border-right">
                    <td class="col-md-6 align-items-center">
                      <div class="td-align">
                        <b>
                          <span class="">{{'VIBRATION.DISTANCE' | translate}}</span>
                        </b>
                      </div>
                    </td>
                    <td class="col-md-6 align-items-center ">
                      <div class="td-align">
                        <span>{{ activeVibrationsNewModel().distance}} </span>
                      </div>
                    </td>
                  </tr>
                  <tr class="no-border-right">
                    <td class="col-md-6 align-items-center">
                      <div class="td-align">
                        <b>
                          <span>{{'VIBRATION.PIC' | translate}}</span>
                        </b>
                      </div>
                    </td>
                    <td class="col-md-6  align-items-center">
                      <div class="td-align">
                        <span>{{ activeVibrationsNewModel().picVibration | number : '1.2-2'}}</span>
                      </div>
                    </td>
                  </tr>
                  <tr class="no-border-right">
                    <td class="col-md-6 align-items-center">
                      <div class="td-align">
                        <b>
                          <span>{{'VIBRATION.DATE_RECORDING' | translate}}</span>
                        </b>
                      </div>
                    </td>
                    <td class="col-md-6  align-items-center">
                      <div class="td-align">
                        <span>{{ activeVibrationsNewModel().header.timestamp | date : 'dd/MM/yyyy, HH:mm:ss'}}</span>
                      </div>
                    </td>
                  </tr>
                  <tr class="no-border-right">
                    <td class="col-md-6 align-items-center">
                      <div class="td-align">
                        <b>
                          <span class="">{{'VIBRATION.VECTOR_SUM' | translate}}</span>
                        </b>
                      </div>
                    </td>
                    <td class="col-md-6  align-items-center">
                      <div class="td-align">
                        <span>{{ activeVibrationsNewModel().vecSomme | number : '1.2-2' }}</span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            <!-- </div> -->
          </div>
          <div class="charts-info-box-right ">
            <table class="table-bordered  ">
              <tbody>
                <!-- inputs with vibration notes -->
                @for (note of notes().notes; track note; let i = $index) {
                  <tr>
                    <td class="col-md-6 align-items-center">
                      <div class="td-align">
                        <b>
                          <span>{{'VIBRATION.NOTE' | translate}}</span>
                        </b>
                      </div>
                    </td>
                    <td class="col-md-6  align-items-center">
                      <div class="td-align td-input">
                        <span>{{ note.value }}</span>
                        @if (notes() != undefined) {
                          <i title="Edit" class="fas fa-edit"
                          (click)="openEditNotesModal(editNotesModal)"></i>
                        }
                      </div>
                    </td>
                  </tr>
                }
                <tr>
                  <td class="col-md-6 align-items-center">
                    <div class="td-align">
                      <b>
                        <span>{{'VIBRATION.LONGITUDE' | translate}}</span>
                      </b>
                    </div>
                  </td>
                  <td class="col-md-6  align-items-center">
                    <div class="td-align">
                      <span>{{ activeVibrationsNewModel().header.longitude }}</span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="col-md-6 align-items-center">
                    <div class="td-align">
                      <b>
                        <span class="">{{'VIBRATION.LATITUDE' | translate}}</span>
                      </b>
                    </div>
                  </td>
                  <td class="col-md-6  align-items-center">
                    <div class="td-align">
                      <span class="">{{ activeVibrationsNewModel().header.latitude }}</span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      }


      @if (activeVibrationsOldModel() != undefined) {
        <div class="charts-info-box left">
          <div id="conteneur-table">
            <table class="table table-bordered col-md-12" id="table_analyse_projet">
              <tbody>
                <tr>
                  <td class="col-md-3 align-items-center ">
                    <div class="td-align">
                      <b>
                        <span class="">{{'VIBRATION.SURPRESSION' | translate}}</span>
                      </b>
                    </div>
                  </td>
                  <td class="  align-items-center ">
                    <div class="td-align">
                      <span class="">{{ activeVibrationsOldModel().surpression}}</span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="col-md-3 align-items-center ">
                    <div class="td-align">
                      <b>
                        <span class="">{{'VIBRATION.DISTANCE' | translate}}</span>
                      </b>
                    </div>
                  </td>
                  <td class="  align-items-center ">
                    <div class="td-align">
                      <span class="">{{ activeVibrationsOldModel().distance}}</span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="col-md-3 align-items-center ">
                    <div class="td-align">
                      <b>
                        <span class="">{{'VIBRATION.PIC' | translate}}</span>
                      </b>
                    </div>
                  </td>
                  <td class="  align-items-center ">
                    <div class="td-align">
                      <span class="">{{ activeVibrationsOldModel().picVibration}}</span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      }
    </div>


    @if (activeVibrationsNewModel() != undefined) {
      <div class="charts scrollable-container">
        <!--canvas for the Main charts-->
        @if (chartWindow() == 0) {
          <div class="chart-box-left col-md-9 ">
            @for (a of activeVibrationsNewModel().channels; track a; let i = $index) {
              <div class=" chart-box "
                [ngStyle]="{'height' : hauteur() != 0 ? hauteur() +'%' : '75px'}">
                @if (a.maxValue > 0) {
                  <div class="chart" style="height: 100%;">
                    <canvas attr.id="canvas-{{i}}" style="height: 100%;"></canvas>
                  </div>
                }
              </div>
            }
          </div>
        }
        <!--right side for Main charts-->
        @if (chartWindow() == 0) {
          <div class="chart-box-right col-md-3">
            @for (a of activeVibrationsNewModel().channels; track a; let i = $index) {
              <div class="chart-box border-left"
                [ngStyle]="{'height' : hauteur() != 0 ? hauteur() +'%' : '75px'}">
                @if (a.maxValue > 0) {
                  <div class="chart-info">
                    <p>{{'VIBRATION.CHANNEL' | translate}} {{i+1}} ({{channelNames[i] | translate }})</p>
                    <p>{{findMaxAbsValue(a.minValue, a.maxValue) | number : '1.2-2' }} {{valueTypes[i]}}</p>
                  </div>
                }
              </div>
            }
          </div>
        }
        <!--canvas for the FFT charts-->
        @if (chartWindow() == 1) {
          <div class="chart-box-left col-md-9 ">
            <div class="chart-fft">
              <canvas id="canvas-fft"></canvas>
            </div>
          </div>
        }
        <!--right side for FFT charts-->
        @if (chartWindow() == 1) {
          <div class="chart-box-right col-md-3">
            @for (a of activeVibrationsNewModel().ffts; track a; let j = $index) {
              <div class="chart-box border-left"
                [ngStyle]="{'height' : hauteur() != 0 ? hauteur() +'%' : '75px'}">
                <div class="chart-info">
                  @if (a.maxHz > 0) {
                    <p>{{'VIBRATION.CHANNEL' | translate}} {{j+1}} ({{channelNames[j] | translate }})</p>
                  }
                  @if (a.maxHz > 0) {
                    <p>Pic FFT: {{a.maxHz| number : '1.0-0'}} Hz</p>
                  }
                </div>
              </div>
            }
          </div>
        }
        <!--NORME window-->
        @if (chartWindow() == 2) {
          <div class="chart-box-left-95">
            <div class="left ">
              <div class="pond-type col-md-12">
                <!-- <span class="item-title ">Ponderation:</span> -->
                <ng-select name="ponderationType" id="ponderationType" [items]="ponderationTypes" #selectPtControl="ngModel"
                  bindLabel="name" [(ngModel)]="selectedPonderationType" [disabled]="true" class="col-md-6" required>
                </ng-select>
              </div>
              <table class="table table-bordered no-border-bottom col-md-12">
                <tbody>
                  @for (a of activeVibrationsNewModel().channels; track a; let i = $index; let isLast = $last) {
                    <tr
                      class="no-border ponderation">
                      @if (a.maxValuePondere > 0) {
                        <td class="col-md-6 align-items-center ">
                          <b>
                            <span class="">{{channelNames[i]| translate}}</span>
                          </b>
                        </td>
                      }
                      @if (a.maxValuePondere > 0) {
                        <td class="col  align-items-center">
                          <span>{{ findMaxAbsValue(a.minValuePondere, a.maxValuePondere) | number : '1.2-2' }} mm/s </span>
                        </td>
                      }
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        }
        <!--EQUIPMENT window-->
        @if (chartWindow() == 3) {
          <div class="chart-box-left-95">
            <div class="left ">
              <div class="pond-type col-md-12">
              </div>
              <table class="table table-bordered col-md-12">
                <tbody>
                  <tr class="no-border-right">
                    <td class="col-md-6 align-items-center ">
                      <div class="td-align">
                        <b>
                          <span class="">{{'VIBRATION.EQUIPMENT' | translate}}</span>
                        </b>
                      </div>
                    </td>
                    <td class="col align-items-center no-border-right">
                      <div class="td-align">
                        <span>{{ findEqipmentType(activeVibrationsNewModel().header.equipmentType) }} </span>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td class="col-md-6 align-items-center">
                      <div class="td-align">
                        <b>
                          <span class="">{{'VIBRATION.SERIAL_NUMBER' | translate}}</span>
                        </b>
                      </div>
                    </td>
                    <td class="col  align-items-center no-border-right">
                      <div class="td-align">
                        <span>{{ activeVibrationsNewModel().header.equipementId}} </span>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td class="col-md-6 align-items-center">
                      <div class="td-align">
                        <b>
                          <span>{{'VIBRATION.DATE_CALIBRATION' | translate}}</span>
                        </b>
                      </div>
                    </td>
                    <td class="col  align-items-center no-border-right">
                      <div class="td-align">
                        <span>{{ activeVibrationsNewModel().header.dateOfCalibration | date : 'dd/MM/yyyy'}}</span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        }
        @if (chartWindow() == 2) {
          <div class="chart-box-right">
            @for (a of activeVibrationsNewModel().ffts; track a; let j = $index) {
              <div class="chart-box-0">
              </div>
            }
          </div>
        }
      </div>
    }

    <!--buttons tabs at the bottom -->
    @if (activeVibrationsNewModel() != undefined) {
      <div class="panel-heading">
        <ul class="nav nav-tabs">
          <li (click)="changeWindow(0)" class="btn-tabs" [ngClass]="{'active':chartWindow() == 0}"><a
          data-toggle="tab">MAIN</a></li>
          <li (click)="changeWindow(1)" class="btn-tabs" [ngClass]="{'active':chartWindow() == 1}"><a
          data-toggle="tab">FFT</a></li>
          <li (click)="changeWindow(2)" class="btn-tabs" [ngClass]="{'active':chartWindow() == 2}"><a
          data-toggle="tab">NORME</a></li>
          <li (click)="changeWindow(3)" class="btn-tabs" [ngClass]="{'active':chartWindow() == 3}"><a
          data-toggle="tab">{{'VIBRATION.EQUIPMENTBIG' | translate}}</a></li>
        </ul>
      </div>
    }
  </div>

  <ng-template #editNotesModal>
    <div class="modal-header">
      <h4 class="modal-title pull-left">{{'VIBRATION.NOTEEDIT' | translate }}</h4>
      <button type="button" class="close pull-right" aria-label="Close" (click)="closeModal()">
        <span aria-hidden="true">×</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="modal-content">
          @for (note of notesEdit().notes; track note; let i = $index) {
          <div class="modal-content-item" >
            <label for="date">{{'VIBRATION.NOTE' | translate }} </label>
            <input type="text" name="name" id="name" [(ngModel)]="note.value" maxlength="250" #name="ngModel" />
          </div>
        }
      </div>
    </div>
    <div class="modal-footer">
      <div>
        <button class="btn btn-outline-success pull-left" style="margin-right:10px;" type="submit" (click)="saveNotes()">{{'GLOBAL.CONFIRMER' | translate}}</button>
      </div>
      <button type="button" class="btn btn-secondary" (click)="closeModal()">{{'GLOBAL.FERMER' | translate}}</button>
    </div>
  </ng-template>
